import type {NotFoundRouteProps} from "@tanstack/react-router";
import {GenericErrorComponent} from "~/components/genericErrorComponent";
import {useIntellsysDevtoolsConfiguration} from "~/contexts/intellsysDevtoolsClientContext";

export function DefaultNotFoundComponent({data, isNotFound, routeId}: NotFoundRouteProps) {
    const intellsysDevtoolsConfiguration = useIntellsysDevtoolsConfiguration();

    if (intellsysDevtoolsConfiguration.insaneLogs.tanstackRouterDebugging === true) {
        console.info(+new Date(), "tanstackRouterDebugging", "?", "notFoundComponent");
    }

    if (intellsysDevtoolsConfiguration.insaneLogs.notFoundComponentLogs === true) {
        console.groupCollapsed(+new Date(), "notFoundComponentLogs", "?", "notFoundComponent");
        console.log("data", data);
        console.log("isNotFound", isNotFound);
        console.log("routeId", routeId);
        console.groupEnd();
    }

    return <GenericErrorComponent error="404" />;
}
